import React, { useState } from 'react';
import { Typography } from 'kangarootime-ui';
import { Collapse } from '@material-ui/core';
import moment from 'moment';

const Event = ({ event }) => {
  const [isExpanded, setExpand] = useState(false);
  const { title, allDay, starts_at: startsAt, ends_at: endsAt, description } = event;
  const formatTime = date => moment(date).format('h:mm a');
  const timeString = startsAt && endsAt ? `${formatTime(startsAt)} - ${formatTime(endsAt)}` : formatTime(startsAt);

  // don't like dangerouslySetInnerHTML but the content we're getting back is in html
  return (
    <div style={{ padding: '4px 0' }}>
      <div className='flex-rows' style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => setExpand(!isExpanded)}>
        <Typography style={{ fontSize: '0.875rem', lineHeight: 'normal', color: '#5F5F5F', flex: 1 }}>{title} {allDay ? 'All Day' : timeString}</Typography>
        <i className={`fa fa-chevron-${isExpanded ? 'up' : 'down'}`} style={{ color: '#5F5F5F' }} />
      </div>
      <Collapse in={isExpanded}>
        <Typography
          style={{ fontSize: '0.875rem', lineHeight: 'normal', color: '#5F5F5F' }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Collapse>
    </div>
  );
};

export default Event;
